<template>
  <div class="container my-account">
    <AppBreadcrumbs back-link="/account/" />

    <AccountResetPassword
      :auto-login="true"
      redirect="/"
    />
  </div>
</template>

<script setup>
import { useBreadcrumbs } from '~layers/app/composables/useBreadcrumbs.ts'

const { t } = useI18n({ useScope: 'global' })
const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: t('Reset Password'),
  parents: [
    {
      label: t('Account'),
      url: 'account',
    },
  ],
})

const { pageView } = useDataLayer()
pageView('other', t('Reset Password'))

useHead({
  meta: [
    { hid: 'robots', name: 'robots', content: 'noindex, follow' },
  ],
})
</script>

<style>
@import url("~layers/app/pages/account.css");
</style>
